import React from "react";

const AboutPromo = () => {
  return (
    <section className="gauto-about-promo section_70">
      <div className="container">
        <div className="row">
          {/* Promo Text */}
          <div className="col-md-12">
            <div className="about-promo-text">
              <h3>
                Experience Safe and Comfortable Rides with <span>Shambhu Cabs</span> Today!
              </h3>
            </div>
          </div>

          {/* Promo Image */}
          <div className="col-md-12">
            <div className="about-promo-image">
              <img src="/img/cars.png" alt="Shambhu Cabs Promo" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPromo;
